import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ClaimValidationResultGroup } from '@jms/model';

@Injectable()
export class ContractorValidationService {

    private readonly api = 'https://__tenant__/api/portal/contractor/operations/workorder';
    private readonly http = inject(HttpClient);

    constructor() { }


    public canClaim(stageId: string): Observable<ClaimValidationResultGroup> {
        return this.http.get<ClaimValidationResultGroup>(`${this.api}/can-submit-claim/${stageId}`);
    }

    public canComplete(stageId: string): Observable<ClaimValidationResultGroup> {
        return this.http.get<ClaimValidationResultGroup>(`${this.api}/can-complete/${stageId}`);
    }
}